import { useFormContext } from 'react-hook-form'

import { FormError } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'
import { Input } from '@fortem-monorepo/react-ui'

export interface IssuerNameFormFieldProps {}

export const IssuerNameFormField: React.FC<IssuerNameFormFieldProps> = ({}) => {
  const { control, register } = useFormContext<{ issuer: string }>()

  return (
    <FormField
      name="issuer"
      control={control}
      render={() => {
        return (
          <FormItem>
            <div className="flex items-center gap-2">
              <FormLabel>Issuer</FormLabel>
              <FormError />
            </div>
            <Input {...register('issuer')} placeholder={'Enter an issuer...'} />
          </FormItem>
        )
      }}
    />
  )
}
